export default "__VITE_ASSET__BDRihDdq__"